/* eslint-disable no-debugger */

export const localValidate = (formState) => {
  let errors = {};

  // File Type
  if (formState.fileTypeId < 0) {
    errors.fileTypeId = 'File Type is required';
  }

  // File Name
  if (!formState.attachmentName.trim()) {
    errors.attachmentName = 'File Name is required';
  } else if (formState.attachmentName.trim().length > 200) {
    errors.attachmentName = 'File Name cannot exceed 200 characters';
  }


  // Attachment Description
  if (formState.attachmentDescription.trim()) {
    if (formState.attachmentDescription.trim().length > 7000) {
      errors.attachmentDescription = 'Description cannot exceed 7000 characters';
    }
  }

  // Attachment URL
  if (!formState.attachmentUrl && !formState.attachmentFile?.size) {
    errors.attachmentFile = 'Attachment File is required';
  }

  // Check for duplicate file type if adding new attachment
  if (formState.attachmentUrl.length === 0  && formState.uploadedAttachments.some(x => x.id === formState.fileTypeId) && formState.attachmentName) {
    errors.fileTypeId = 'You have already uploaded an attachment of this type. Please select a different type.';
  }

  return errors;
};

const NTAttachmentFormValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default NTAttachmentFormValidation;